import React from 'react';
import { motion } from 'framer-motion';
import { ConbersaLogo } from './ConbersaLogo';

const LoadingScreen: React.FC = () => {
	return (
		<div className="fixed inset-0 bg-background flex items-center justify-center">
			<div className="flex flex-col items-center space-y-6">
				{/* Animated Logo */}
				<motion.div
					initial={{ scale: 0.8, opacity: 0 }}
					animate={{
						scale: [0.8, 1.1, 1],
						opacity: 1,
						rotate: [0, 5, -5, 0]
					}}
					transition={{
						duration: 1.5,
						ease: "easeOut",
						rotate: {
							duration: 2,
							repeat: Infinity,
							repeatType: "reverse",
							ease: "easeInOut"
						}
					}}
				>
					<ConbersaLogo size={80} className="drop-shadow-lg" />
				</motion.div>

				{/* Animated Text */}
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
					className="text-center"
				>
					<motion.h1
						className="text-3xl font-bold text-foreground mb-2"
						animate={{
							opacity: [0.7, 1, 0.7]
						}}
						transition={{
							duration: 2,
							repeat: Infinity,
							ease: "easeInOut"
						}}
					>
						Conbersa
					</motion.h1>

					{/* Animated dots */}
					<div className="flex items-center justify-center space-x-1">
						<span className="text-muted-foreground">Loading</span>
						<div className="flex space-x-1">
							{[0, 1, 2].map((index) => (
								<motion.div
									key={index}
									className="w-1 h-1 bg-primary rounded-full"
									animate={{
										scale: [1, 1.5, 1],
										opacity: [0.5, 1, 0.5]
									}}
									transition={{
										duration: 1,
										repeat: Infinity,
										delay: index * 0.2,
										ease: "easeInOut"
									}}
								/>
							))}
						</div>
					</div>
				</motion.div>

				{/* Subtle background animation */}
				<motion.div
					className="absolute inset-0 pointer-events-none"
					initial={{ opacity: 0 }}
					animate={{ opacity: 0.03 }}
					transition={{ delay: 1, duration: 1 }}
				>
					<motion.div
						className="absolute top-1/4 left-1/4 w-32 h-32 bg-primary rounded-full blur-3xl"
						animate={{
							scale: [1, 1.2, 1],
							x: [0, 20, 0],
							y: [0, -10, 0]
						}}
						transition={{
							duration: 8,
							repeat: Infinity,
							ease: "easeInOut"
						}}
					/>
					<motion.div
						className="absolute bottom-1/4 right-1/4 w-24 h-24 bg-accent rounded-full blur-3xl"
						animate={{
							scale: [1, 1.3, 1],
							x: [0, -15, 0],
							y: [0, 15, 0]
						}}
						transition={{
							duration: 6,
							repeat: Infinity,
							ease: "easeInOut",
							delay: 2
						}}
					/>
				</motion.div>
			</div>
		</div>
	);
};

export default LoadingScreen;
